import { LEGAL_DOCUMENT_PATHS } from '@provision/landing-page-utils';
import { useLegalDocumentSegmentToken } from 'src/graphql/entities/legal-document/use-legal-document-segment-token';
import type { LegalDocumentSurface } from 'src/pages/Settings/memberships/hooks/use-legal-document-surface';
import { useSegmentBaseUrl } from 'src/pages/Settings/memberships/hooks/use-segment-base-url';

/**
 * Undefined until the document is saved. Always carries the segment token, so a link still shows
 * this segment's document if its address later serves other segments too.
 */
export const useLegalDocumentLiveUrl = (
  partnerId: number | null,
  brandId: string | undefined,
  surface: LegalDocumentSurface | null,
): string | undefined => {
  const activePartnerId = surface ? partnerId : null;
  const baseUrl = useSegmentBaseUrl(activePartnerId, brandId);
  const token = useLegalDocumentSegmentToken(activePartnerId, brandId);

  if (!baseUrl || !surface?.savedDocument) return undefined;

  const url = `${baseUrl}${LEGAL_DOCUMENT_PATHS[surface.kind]}`;

  return token ? `${url}?segment=${token}` : url;
};
